/*  js-cart-notification 0.13 */

/*----------------------
   CART NOTIFICATION
---------------------- */
CartNotification = {
    init: function () {
        $('a[href="#open-cart"]').on("click", function (e) {
            e.preventDefault();
            $(".cart-notification").addClass("cart-notification-active");
            $("body").addClass("cart-notification-open");
        });

        // close cart notification
        $(".cart-notification__header__close-btn").click(function () {
            $(".cart-notification").removeClass("cart-notification-active");
            $("body").removeClass("cart-notification-open");
        });

        $("body").on("click", function (e) {
            if (!$(e.target).closest('.cart-notification__header__close-btn, .cart-notification, a[href="#open-cart"').length) {
                $(".cart-notification").removeClass("cart-notification-active");
                $("body").removeClass("cart-notification-open");
            }
        });

        // update totals and add button handlers
        updateCartTotals();

        // ADD TO CART button from product page
        $(".button-add-cart").click(function () {
            const productID = $(this).attr('data-id');
            const productParent = $(this).attr('data-parent');
            let productQty = $('#product_data').find('input[name="quantity"]').val();
            const randomID = Math.random() * 1e17;
            if (!productQty) productQty = 1;
            if (productQty <= 0) return;
            $(this).addClass("product-adding");

            // look for all the product addons
            let items = [];
            let addonsEl = $('#product_data').find('[name="product_addon"]');

            // parse all the addons
            $(addonsEl).each(function (index) {
                let price = $(this).find('[name="price"]').attr("data-price");
                let id = $(this).attr("data-id");
                let parent = $(this).attr("data-parent");
                let qty = $(this).find('[name="quantity"]').val();
                let propName = $(this).find('[name="property"]').attr("data-name");
                let propValue = $(this).find('[name="property"]').attr("data-value");
                let properties = { '_link': randomID };
                if (propName) properties[propName] = propValue;

                if (qty > 0) {
                    items.push({
                        'id': Number(id), 'quantity': Number(qty),
                        properties
                    });
                }
            });

            // check if we must also add extra properties
            let addpropsEl = $('#product_data').find('[name="product_property"]');

            // parse all the addons
            properties = {};
            $(addpropsEl).each(function (index) {
                let propName = $(this).attr("data-name");
                let propValue = $(this).attr("data-value");
                if (propName) properties[propName] = propValue;
            });

            // keep track of parent product
            properties['_parent'] = productParent;

            // if this item has addons, add the master link id
            if (items.length) properties['_mlink'] = randomID;

            // add the product to the array
            items.push({ 'id': Number(productID), 'quantity': Number(productQty), ...(properties ? { properties } : {}) });

            let json = { 'items': items, 'sections': 'section-cart-notification' };

            // make rest call to shopify
            $.post(window.Shopify.routes.root + 'cart/add.js', json, null, "json")
                .done(function (data) {
                    addToCart(data);
                    $(".cart-notification").addClass("cart-notification-active");
                    $("body").addClass("cart-notification-open");
                })
                .fail(function (data) {

                    //var json = JSON.parse(data);
                    alert(data['responseJSON']["description"]);


                })
                .always(function (data) {
                    $(".button-add-cart").removeClass("product-adding");

                });
        });

        // ADD TO CART NOTIFICATION
        function addToCart(data) {
            const cartEl = $(".cart-notification__products");
            cartEl.empty();
            cartEl.append($(data.sections['section-cart-notification']).html());

            // update totals
            updateCartTotals();
        }

        // REMOVE FROM CART NOTIFICATION
        function removeFromCart(element) {
            const cartEl = $(".cart-notification__products").find(".cart-notification__products__item");

            // mark this element as deleted, check if has associated elements
            let json = { 'line': $(element).attr("data-line"), 'quantity': 0 };
            $(element).attr("data-line", "removed");
            // check if its a master product
            const mlink = $(element).attr("data-mlink");
            if (mlink) {
                // look for linked products to this and remove them also (gifts, accessories, ...)
                $(cartEl).find("[data-link='" + mlink + "'").each(function () {
                    json.push({ 'line': $(this).attr("data-line"), 'quantity': 0 });
                    $(this).attr("data-line", "removed");
                });
            }

            // renumber rest of lines
            let index = 1;
            $(cartEl).each(function () {
                if ($(this).attr("data-line") != "removed") {
                    $(this).attr("data-line", index);
                    index++;
                }
            });

            // make rest call to shopify
            $.post(window.Shopify.routes.root + "cart/change.js", json, null, "json")
                .done(function (data) {
                    // remove deleted elements from cart notification
                    $(cartEl).each(function () {
                        if ($(this).attr("data-line") == "removed") $(this).fadeOut(250, function () {
                            $(this).remove();
                            // if cart notification is empty, auto close it
                            if ($(".cart-notification__products__item").length == 0) {
                                $(".cart-notification").removeClass("cart-notification-active");
                                $("body").removeClass("cart-notification-open");
                            }
                        });
                    });
                    updateCartTotals();

                })
                .fail(function (data) {
                    // something gone wrong, ask for entire cart
                    $.get(window.Shopify.routes.root + "?sections=section-cart-notification", "", function (data) {
                        const cartEl = $(".cart-notification__products");
                        cartEl.empty();
                        cartEl.append(data['section-cart-notification']);

                        // update totals
                        updateCartTotals();
                    }, "json");
                })
                .always(function (data) {
                });
        }

        // UPDATE CART TOTALS NOTIFICATION
        function updateCartTotals() {
            const cartEl = $(".cart-notification__products").find(".cart-notification__products__item");

            let totalQty = 0;
            let totalAmount = 0;
            $(cartEl).each(function (index) {
                const line = $(this).attr("data-line");
                if (line == "removed") return;

                const qtyEl = $(this).find(".cart-notification__products__item__quantity");
                let qty = 1;
                if (qtyEl) qty = +$(qtyEl).val();
                const prevQty = +$(qtyEl).attr("data-qty");

                let priceEl = $(this).find("[data-price]");
                let price = +$(priceEl).data("price");

                let ElTotalPriceObj = $(this).find(".cart-notification__products__item__price");
                let ElTotalPrice = price * qty;
                $(ElTotalPriceObj).html(formatMoney(ElTotalPrice));

                totalQty += qty;
                totalAmount += qty * price;

                // handle quantity change
                const params = { "line": line, "parent": $(this).attr("data-parent") };
                $(qtyEl).off('change').on('change', params, function (e, param1) {

                    // update quantity api call
                    //let new_qty = +$(e.target).val() + +param1;
                    let new_qty = $(e.target).val();

                    let qty_valid = true;
                    let parentQty = 0;
                    $(cartEl).each(function () {
                        const line = $(this).attr("data-line");
                        if (line == "removed") return;

                        // if this line is the line to set qty changed
                        if ($(this).attr("data-line") == e.data['line']) {
                            parentQty += new_qty;
                        } else {
                            parentQty += +$(this).find("input.cart-notification__products__item__quantity").val();
                        }

                    });
                    if (!qty_valid) return;

                    let json = { 'line': e.data['line'], 'quantity': new_qty };

                    // make rest call to shopify
                    $.post(window.Shopify.routes.root + 'cart/change.js', json, null, "json")
                        .done(function (data) {
                            $(e.target).attr("data-qty", new_qty);
                            $(e.target).val(new_qty);
                        })
                        .fail(function (data) {
                            // show not enough stock error?
                            alert("You have all available stock of this product already in cart.");
                        })
                        .always(function (data) {
                            updateCartTotals();
                        });
                });

                // handle remove button click
                $(cartEl).find(".btn-remove").off('click').on('click', function (e) {
                    // check it's not already removed
                    let el = $(e.target).closest(".cart-notification__products__item");
                    if ($(el).attr("data-line") != "removed") removeFromCart(el);
                });

                // handle cart notification plus and minus buttons
                $(cartEl).find('.plus').off('click').on('click', function () {
                    $(this).siblings('input[type=number]')[0].stepUp()
                    $(this).siblings('input[type=number]').trigger('change');

                });

                $(cartEl).find('.minus').off('click').on('click', function () {
                    $(this).siblings('input[type=number]')[0].stepDown()
                    $(this).siblings('input[type=number]').trigger('change');
                });
            });

            // update total cart
            const totalEl = $(".cart-notification__bottom").find(".cart-notification__price");
            $(totalEl).html(formatMoney(totalAmount));

            // update also the num-cart total quantity
            $(".num-cart").html(totalQty);

            // if no items, update cart-notification to empty
            if (totalQty == 0) {
                $(".cart-empty").show();
                $(".cart-notification__bottom__btn.btn--checkout").hide();
                $(".cart-notification__bottom__btn.btn--shop").show();

            } else {
                $(".cart-empty").hide();
                $(".cart-notification__bottom__btn.btn--checkout").show();
                $(".cart-notification__bottom__btn.btn--shop").hide();
            }
        }
    }
};

CartNotification.init();
